import { Button, Col, Row } from "reactstrap";
import { ButtonsTitle, Href } from "../../../Constants/Constants";
import { Phone } from "react-feather";

const Buttons = () => {
  return (
    <section>
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{ButtonsTitle}</h2>
            </div>
            <div className="element-card-body typography">
              <Button color="success" size="xl" tag={"a"} className="icon-btn button-effect is-animating font_label" href={Href}><Phone /></Button>
              <Button color="danger" size="xl" tag={"a"} className="icon-btn button-effect is-animating font_label" href={Href}><Phone /></Button>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default Buttons;
